import React from 'react';
import styled from "styled-components";
import houseCleaning from '../../../assets/images/house_cleaning_service.webp'
import deepCleaning from '../../../assets/images/deepcleaning.webp'
import moveCleaning from '../../../assets/images/move_in.webp'
import {Service} from "./Service";
import {FlexWrapper} from "../../../components/FlexWrapper";
import {SectionTitle} from "../../../components/SectionTitle";
import {Container} from "../../../components/container/Container";
import {theme} from "../../../styles/Theme";
import {font} from "../../../styles/Common";

export const OurService = () => {
    return (
        <OurServiceStyled id={'cleaningService'}>
            <Container>
                <SectionPlace>
                    <SectionTitle>Our cleaning services</SectionTitle>
                    <SectionText>Whether you're relocating, managing a vacation rental, or simply seeking a clean and
                        comfortable home, we are here to assist you.</SectionText>
                </SectionPlace>
                <FlexWrapperStyled wrap={'wrap'} justify={'space-between'} align={'center'}>
                    <Service title={'Regular House Cleaning'}
                             description={'Professional house and apartment cleaning available weekly, bi-weekly, or monthly. Perfect for maintaining a clean, fresh home all year round.'}
                             src={houseCleaning}
                             alt="Regular house cleaning service near me in Adelaide"
                    />
                <Service title={'Deep (Spring) Cleaning'}
                         description={"Thorough top-to-bottom cleaning ideal for seasonal refresh or before starting recurring services. We target hidden dust, grime, and buildup."}
                         src={deepCleaning}
                         alt="Deep spring cleaning services in Adelaide"

                />
                <Service title={'Move In-Out Cleaning'}
                         description={'Get your space professionally cleaned before moving in or after moving out. Ideal for end-of-lease, bond cleaning, or handing over a spotless property.'}
                         src={moveCleaning}
                         alt="Move out and end of lease cleaning service in Adelaide"/>
            </FlexWrapperStyled>
        </Container>
</OurServiceStyled>

)
    ;
};

const OurServiceStyled = styled.section`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    //background-color: #ade6d2;
    position: relative;



`
const SectionPlace = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 70px;

`
const SectionText = styled.span`
    //font-family: 'Montserrat', sans-serif;
    //font-weight: 400;
    //font-size: 14px;
    //letter-spacing: 0.06em;
    text-transform: uppercase;
    text-align: center;
    color: #52525e;
    width: 50%;
    padding-top: 25px;
    @media ${theme.media.mobile}{
        width: 100%;

    }

    ${font({
        family: '"Montserrat", sans-serif',
        weight: 400,
        color: '#52525e',
        Fmin: 12,
        Fmax: 18,
        letterSpacing: '0.06em'
    })}

`

const FlexWrapperStyled = styled(FlexWrapper)`
    @media ${theme.media.tablet} {
        flex-direction: column;
        align-items: center;
        gap: 40px; // добавление промежутка между блоками на мобильной версии
    }`